export default __webpack_public_path__ + "static/media/a11.3ae69ad2.webp";